import React from 'react';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import fr from 'facet-rest';
import { followRelationship } from 'Helpers/Affordances';
import { useSnackbarContext } from 'Context/SnackbarContext';

export const ResendVerificationCodeButton = ({ setAuthCollection }) => {
  const { resource } = useMetaLayoutContext();
  const workingRef = React.useRef(false);
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();

  return resource.withRelationship(fr.relationships.mfaPreferenceSms.name, (rel) => {
    const handleResend = async () => {
      if (workingRef.current === true) {
        return;
      }

      workingRef.current = true;

      try {
        const coll = await followRelationship(rel);
        setAuthCollection(coll);
        displaySuccess('Verification code sent');
      } catch (err) {
        displayErrorMessage(err, err.errors);
      }

      workingRef.current = false;
    };

    return (
      <FDSecondaryActionButton
        onClick={handleResend}
        {...dataAttrs('resend-code-btn')}
        label={'Send code again'}
      />
    );
  }, () => null);
};

ResendVerificationCodeButton.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
};
